import Component from '@glimmer/component'
import type { UIScopeName } from 'teacher-ui-client/reporting/ui-scope/route'
import type { ReportData } from 'teacher-ui-client/components/reporting/reading-eggspress/read-aloud-fluency/students-table/report-loader'
import { StudentsTable } from 'teacher-ui-client/components/reporting/reading-eggspress/read-aloud-fluency/students-table/table'
import { BasePageSelector as PageSelector } from 'teacher-ui-client/components/base/page-selector'
import { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'
import type SessionService from 'teacher-ui-client/services/session'
import { service } from '@ember/service'

interface ReportSignature {
  Args: {
    isReloading?: boolean
    scopeName: UIScopeName
    reportData: ReportData
  }
}

export class StudentsTableReport extends Component<ReportSignature> {
  @service session!: SessionService

  get isSubco() {
    return this.session.currentTeacher.subcoFor(SubscriptionType.Reading)
  }

  <template>
    <div class="overflow-x-auto print:block print:max-h-[unset] print:overflow-visible">
      <StudentsTable
        data-test-students-table
        class="w-full print:w-full"
        @isReloading={{@isReloading}}
        @isSubco={{this.isSubco}}
        @studentsReportData={{@reportData.students}}
      />
    </div>
    <PageSelector
      class="mx-2 my-3"
      @pageCount={{@reportData.meta.total_pages}}
      @itemCount={{@reportData.meta.total_entries}}
    />
  </template>
}
